import React from 'react';
import styles from './index.module.scss';
import DataScreening from './components/DataScreening';
import OperatingPowerCurve from './components/OperatingPowerCurve';
import SocialBenefitsOfNewEnergy from './components/SocialBenefitsOfNewEnergy';

const LeftBox = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.top}>
        {/* 数据总览 */}
        <DataScreening />
      </div>
      <div className={styles.center}>
        {/* 运行功率曲线 */}
        <OperatingPowerCurve />
      </div>
      <div className={styles.bottom}>
        {/* 新能源社会效益 */}
        <SocialBenefitsOfNewEnergy />
      </div>
    </div>
  );
};

export default LeftBox;
